var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tov-form"},[(_vm.isFormRendered)?_c('div',{staticClass:"tov-form__wrapper"},[_c('FirmInput',{attrs:{"firm-title":_vm.formData.legalPersonInfo.full_name}}),_c('INNInput',{attrs:{"firm-info":_vm.formData.legalPersonInfo}})],1):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }